import { render, staticRenderFns } from "./MainServices.vue?vue&type=template&id=2240b49c&scoped=true&"
import script from "./MainServices.vue?vue&type=script&lang=js&"
export * from "./MainServices.vue?vue&type=script&lang=js&"
import style0 from "./MainServices.vue?vue&type=style&index=0&id=2240b49c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2240b49c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol})
